// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"2353fe5e","703":"92b64408"}[chunkId] + ".chunk.js";
};